import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PurchaseOrderDataEffects } from './purchase-order-data.effects';
import { FEATURE_NAME, reducer } from './purchase-order-data.reducer';
import { PurchaseOrderDataBuilder } from './purchase-order-data.builder';
import { PurchaseOrderDataService } from './purchase-order-data.service';
import { PurchaseOrderDataStore } from './purchase-order-data.store';
import { PurchaseOrderDataDispatcher } from './purchase-order-data.dispatcher';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EffectsModule.forFeature([PurchaseOrderDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class PurchaseOrderDataModule {
  static forRoot(): ModuleWithProviders<PurchaseOrderDataModule> {
    return {
      ngModule: PurchaseOrderDataModule,
      providers: [
        PurchaseOrderDataBuilder,
        PurchaseOrderDataDispatcher,
        PurchaseOrderDataService,
        PurchaseOrderDataStore,
      ],
    };
  }
}
